// Function to handle the application of gift status
// localStorage.setItem('GiftEnabled', false);
// alert(localStorage.getItem('GiftOrder'));
// alert(localStorage.getItem('GiftEnabled'));

var giftNoteProp = document.getElementById('gift--note--prop');
var textarea = document.querySelector('.mini-cart__note textarea');
var propGiftCart = document.querySelector('.Gift--note--value dt');
fetch('/cart.js')
.then(response => response.json())
.then(cart => {
    var giftProductID = document.getElementById('gift-label')?.getAttribute('data-product-name');
    var giftProductHandle = document.getElementById('gift-label')?.getAttribute('data-product-handle');
    
    var giftProduct = cart.items.find(item => item.product_id == giftProductID);
    
    if (giftProduct) {
        var cartPageItemsList = document.querySelectorAll('.cart-items tbody .cart-item');
        if(cartPageItemsList){
          cartPageItemsList.forEach(function(item) {
              var itemHandle = item.getAttribute('data-handle');
              if (itemHandle == giftProductHandle) {
                  // localStorage.setItem('GiftNoteVal', '');
                
                if (textarea) {
                  if (textarea.value.trim() !== "") {
                    if(!propGiftCart.innerText.includes('Gift Note')){
                      giftNoteProp.innerText="Gift Note Included";
                    }
                    updateGiftWrapProperties(textarea);
                  }
                }
              }
          });
        }
    }
});
function giftApply(item) {
    var textarea = document.querySelector('.mini-cart__note textarea');
    var carterror = document.querySelector('.mini-cart__note .cart--note--error');
    var loadingSpinner = document.querySelector('.cstm__loading__spinner');
    var btnText = document.querySelector('.cstm--btn--text');
    var btnApply = document.querySelector('.button.cstm--gift--cart--btn');
    var editbtn = document.getElementById('btn--edit');
    var giftNoteInput = document.getElementById('gift-note-input');
    var giftNoteProp = document.getElementById('gift--note--prop');
    var propGiftCart = document.querySelector('.Gift--note--value dt');
    loadingSpinner.classList.remove('hidden');
    btnText.classList.add('hidden');
    if (textarea) {
        if (textarea.value.trim() === "") { 
            localStorage.setItem('GiftNoteVal', " ");
            textarea.value = " ";
            // carterror.style.display = 'block';
            loadingSpinner.classList.add('hidden');
            if(giftNoteInput){
              if(propGiftCart){
                if(!propGiftCart.innerText.includes('Gift Note')){
                  giftNoteInput.value = "";
                  giftNoteProp.innerText="No Gift Note"
                }
              }else{
                giftNoteInput.value = "";
                giftNoteProp.innerText="No Gift Note"
              }
              
              updateGiftWrapProperties(textarea);
              // window.location.reload();
            }
            if(editbtn){
          // alert('s');
              editbtn.style.display = 'none';
            }
            btnText.classList.remove('hidden');
        } else {
            localStorage.setItem('GiftNoteVal', textarea.value.trim());
            // checkAndAddGiftProduct();
            if(giftNoteInput){
              if(propGiftCart){
                if(!propGiftCart.innerText.includes('Gift Note')){
                  giftNoteInput.value = "Gift Note Included";
                  giftNoteProp.innerText="Gift Note Included";
                }
              }else{
                giftNoteInput.value = "Gift Note Included";
                giftNoteProp.innerText="Gift Note Included";
              }
              updateGiftWrapProperties(textarea);
            }
            if(editbtn){
          // alert('s');
              editbtn.style.display = 'inline-block';
            }
            carterror.style.display = 'none';
            btnApply.setAttribute('disabled', 'disabled');
            textarea.setAttribute('disabled', 'disabled');
            loadingSpinner.classList.add('hidden');
            btnText.classList.remove('hidden');
            localStorage.setItem('GiftOrder', true);
        }
      var cartNoteSucess = document.querySelector('.cart--note--success');
      if(cartNoteSucess){
        cartNoteSucess.style.display = 'block';
      }
    } else {
        console.log('Textarea element not found.');
    }
}

// Function to check if the gift product is in the cart and add it if not
function checkAndAddGiftProduct() {
    var loadingSpinner = document.querySelector('.cstm__loading__spinner');
    var btnText = document.querySelector('.cstm--btn--text');
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
        var giftProductID = document.getElementById('gift-label')?.getAttribute('data-product-name');
        var giftProductInCart = cart.items.some(item => item.product_id == giftProductID);
        
        if (!giftProductInCart) {
            const giftProduct = document.querySelector('.gift--product');
            if (giftProduct) {
                const buttonCart = giftProduct.querySelector('.card-information__button .button');
                if (buttonCart) {
                    buttonCart.click();
                    localStorage.setItem('GiftLabel', 'Thank you for sending a gift');
                    localStorage.setItem('GiftEnabled', true);
                    if(localStorage.getItem('GiftEnabled') == 'true'){
                      localStorage.setItem('GiftOrder', true);
                      document.querySelector('.mini-cart__note textarea').value = localStorage.getItem('GiftNoteVal');
                    }else{
                      localStorage.setItem('GiftOrder', false);
                    }
                    loadingSpinner.classList.add('hidden');
                    btnText.classList.remove('hidden');
                  // setTimeout(function() {
                  //   updateGiftLabel();
                  // }, 3000);
                  
                }
            }
        } else {
            console.log('Gift product is already in the cart.');
            loadingSpinner.classList.add('hidden');
            btnText.classList.remove('hidden');
        }
    });
}
function edit_text(){
  event.preventDefault();
  var textarea = document.getElementById('Gift-note');
  var btnApply = document.querySelector('.button.cstm--gift--cart--btn');
  btnApply.removeAttribute('disabled');
  textarea.removeAttribute('disabled');
}

// Function to update the gift label based on localStorage
function updateGiftLabel() {
    var editbtn = document.getElementById('btn--edit');
    var textarea = document.getElementById('Gift-note');
    var giftLabel = document.getElementById('label--text');
    console.log('update gift label called');
    var giftNoteValue = localStorage.getItem('GiftNoteVal');
    console.log(giftNoteValue);
    var giftCheckbox = document.getElementById('gift-input');
    var giftPopup = document.getElementById('gift_popup');
    var cartFooter = document.querySelector('.mini-cart__footer');
    var cartMini = document.querySelector('.mini-cart__inner');
    var btnApply = document.querySelector('.button.cstm--gift--cart--btn');
    var giftNoteInput = document.getElementById('gift-note-input');
    var giftNoteProp = document.getElementById('gift--note--prop');
    var currentURL = window.location.href;
    var propGiftCart = document.querySelector('.Gift--note--value dt');
    if(localStorage.getItem('GiftEnabled') == 'true' && localStorage.getItem('GiftOrder') == 'true'){
      console.log('gift enabled');
      
      giftLabel.innerText = localStorage.getItem('GiftLabel');
      giftLabel.style.color = 'black';
      if (giftCheckbox) giftCheckbox.checked = true;
      document.querySelector('.mini-cart__note textarea').value = giftNoteValue;
      if (giftPopup) giftPopup.open = true;
      if (textarea.value.trim() !== "") {
        if(editbtn){
          // alert('s');
          editbtn.style.display = 'inline-block';
        }
          btnApply.setAttribute('disabled', 'disabled');
          textarea.setAttribute('disabled', 'disabled');
        if(giftNoteInput){
          // if(currentURL.includes('/cart')){
          //   giftNoteProp.innerText="";
          // }else{
          // console.log(propGiftCart.innerText);
          if(propGiftCart){
            if(!propGiftCart.innerText.includes('Gift Note')){
              giftNoteInput.value = "Gift Note Included";
              giftNoteProp.innerText="Gift Note Included";
            }
          }else{
            giftNoteInput.value = "Gift Note Included";
            giftNoteProp.innerText="Gift Note Included";
          }
          
            
          // }
          
        }
      }else{
        // if(currentURL.includes('/cart')){
        //   if(giftNoteInput){
        //     giftNoteInput.value = "No Gift Note";
        //     giftNoteProp.innerText="";
        //   }
        // }else{
          if(giftNoteInput){
            if(propGiftCart){
              if(!propGiftCart.innerText.includes('Gift Note')){
                giftNoteInput.value = "No Gift Note";
                giftNoteProp.innerText="No Gift Note";
              }
            }else{
              giftNoteInput.value = "No Gift Note";
              giftNoteProp.innerText="No Gift Note";
            }
          }
        // }
        
      }
      
      
      // cartFooter.style.overflow = 'auto';
      if(cartFooter){
        cartFooter.style.height = '50%';
      }
      if(cartMini){
        cartMini.style.overflow = 'auto';
      }
    }else{
      if (giftCheckbox){
        // alert(localStorage.getItem('GiftOrder'));
        if (localStorage.getItem('GiftOrder') == 'true') {
            document.querySelector('.mini-cart__note textarea').value = giftNoteValue;
            giftLabel.innerText = localStorage.getItem('GiftLabel');
            if (giftCheckbox) giftCheckbox.checked = true;
            if (giftPopup) giftPopup.open = true;
            if(textarea.value.trim() !== ""){
              if(editbtn){
                // alert('s');
                editbtn.style.display = 'inline-block';
              }
              if(giftNoteInput){
                giftNoteInput.value = "Gift Note Included";
                giftNoteProp.innerText="Gift Note Included";
              }
            }
            giftLabel.style.color = 'black';
            // cartFooter.style.overflow = 'auto';
            if (textarea.value.trim() !== "") {
                btnApply.setAttribute('disabled', 'disabled');
                textarea.setAttribute('disabled', 'disabled');
            }
            if(cartFooter){
              cartFooter.style.height = '50%';
            }
            if(cartMini){
              cartMini.style.overflow = 'auto';
            }
        } else {
            // document.querySelector('.mini-cart__note textarea').value = ' ';
            giftLabel.innerText = 'Gift wrap this order (+ $5)';
            giftLabel.style.color = '#678948';
            if (giftCheckbox) giftCheckbox.checked = false;
            if (giftPopup) giftPopup.open = false;
            // cartFooter.style.overflow = 'unset';
            if(cartFooter){
              cartFooter.style.height = '';
            }
            if(cartMini){
              cartMini.style.overflow = 'unset';
            }
        }
      }
    }
}
// Function to update gift wrap properties
function updateGiftWrapProperties(textarea) {
  // Get current cart
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      var giftLineItem = null;
      
      // Find the gift wrap product in the cart
      cart.items.forEach(function(item) {
         if (item.properties && item.properties['Gift Product'] || item.title.includes('Gift Wrap')) { // Adjust this condition as needed
            giftLineItem = item;
          }
      });

      if (giftLineItem) {
        // Update the cart properties
        var properties = {};
        if (textarea.value.trim() === '') {
          properties['Gift Note'] = 'No Gift Note';
        } else {
          properties['Gift Note'] = textarea.value.trim();
        }
        // Use the Shopify AJAX API to update the cart item
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: giftLineItem.key, // Line item key
            quantity: giftLineItem.quantity, // Keep the same quantity
            properties: properties // Update the properties
          })
        })
        .then(response => response.json())
        .then(cart => {
          console.log('Gift wrap properties updated', cart);
          var currentURL = window.location.href;
          if(currentURL.includes('/cart')){
            // window.location.reload();
          }
          // Optionally refresh the cart drawer here
        })
        .catch(error => console.error('Error updating cart properties:', error));
      }
    });
}
document.body.addEventListener('click', function(event) {
  if (event.target.matches('.cart__checkout-button')){
      console.log('checkout--clicked');
      var textarea = document.querySelector('.mini-cart__note textarea');
      var giftCheckbox = document.getElementById('gift-input');
      var carterror = document.querySelector('.mini-cart__note .cart--note--error');
      var carterror1 = document.querySelector('.mini-cart__note .cart--note--error.cart--error1');
      var GiftEnabled = localStorage.getItem('GiftEnabled');
      // if(localStorage.getItem('GiftOrder') == 'true'){
      localStorage.setItem('GiftNoteVal', textarea.value.trim());
      updateGiftWrapProperties(textarea);
      
      // }
      
      // if (giftCheckbox.checked) {
      //   if(GiftEnabled != 'true'){
      //     event.preventDefault();
      //     // alert('Please Apply Gift Or Uncheck the Checkbox');
      //     carterror1.style.display = 'block';
      //   }else if(GiftEnabled == 'true'){
      //     if (textarea.value.trim() === "") {
      //       console.log('textare--empty');
      //       textarea.value = localStorage.getItem('GiftNoteVal');
      //     }
      //     // localStorage.setItem('GiftEnabled',false);
      //   }else{
      //     if (textarea.value.trim() === "") {
      //       event.preventDefault();
      //       console.log('Gift Text Not Added');
      //       carterror.style.display = 'block';
      //     }
      //   }
        
        
      // }else{
        carterror.style.display = 'none';
        if (textarea.value.trim() === "") {
          console.log('textare--empty');
          textarea.value = ' ';
        }
      // }
  }
});

// Handle checkbox change event
document.body.addEventListener('change', function(event) {
    if (event.target.matches('#gift-input')) {
      setTimeout(function() {
        handleCheckboxChange();
      }, 500);
    }
});

// Handle mini cart actions to reset gift checkbox
document.body.addEventListener('click', function(event) {
    if (event.target.matches('.mini-cart__action[open]>summary') && localStorage.getItem('GiftOrder') === 'false') {
        var giftCheckbox = document.getElementById('gift-input');
        if (giftCheckbox) {
            console.log('summary clicked');
            giftCheckbox.checked = false;
            localStorage.setItem('GiftOrder', false);
            // document.querySelector('.mini-cart__note textarea').value = ' ';
        }
    }
});

// Function to handle checkbox change
function handleCheckboxChange() {
    var giftCheckbox = document.getElementById('gift-input');
    var giftPopup = document.getElementById('gift_popup');
    var cartFooter = document.querySelector('.mini-cart__footer');
    var cartMini = document.querySelector('.mini-cart__inner');
    console.log('Handle checkbox clicked');
    if (giftCheckbox.checked) {
        // if(localStorage.getItem('GiftEnabled')=='true'){
          // alert('working');
          checkAndAddGiftProduct();
        // }else{
          giftPopup.open = true;
          // Ensure checkbox remains checked
          giftCheckbox.checked = true;
          // cartFooter.style.overflow = 'auto';
          if(cartFooter){
            cartFooter.style.height = '50%';
          }
          if(cartMini){
            cartMini.style.overflow = 'auto';
            // cartMini.scrollTo({
            //   top: cartMini.scrollHeight,
            //   behavior: 'smooth'
            // });
          }
        // }
    } else {
        if(cartFooter){
          cartFooter.style.overflow = 'unset';
          cartFooter.style.height = '';
        }
        if(cartMini){
          cartMini.style.overflow = 'unset';
        }
        giftPopup.open = false;
        localStorage.setItem('GiftOrder', false);
        localStorage.setItem('GiftLabel', 'Gift wrap this order (+ $5)');
        removeGiftProduct();
    }
}

// Function to remove the gift product from the cart
function removeGiftProduct() {
    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
        var giftProductID = document.getElementById('gift-label')?.getAttribute('data-product-name');
        var giftProductHandle = document.getElementById('gift-label')?.getAttribute('data-product-handle');
        var giftProduct = cart.items.find(item => item.product_id == giftProductID);
        if (giftProduct) {
            var cartItemsList = document.querySelectorAll('cart-items li');
            if(cartItemsList){
              cartItemsList.forEach(function(item) {
                  var itemHandle = item.getAttribute('data-handle');
                  if (itemHandle == giftProductHandle) {
                      // localStorage.setItem('GiftNoteVal', '');
                      document.querySelector('.mini-cart__note textarea').value = '';
                      item.querySelector('cart-remove-button').click();
                      localStorage.setItem('GiftLabel', 'Gift wrap this order (+ $5)');
                  }
              });
            }
            var cartPageItemsList = document.querySelectorAll('.cart-items tbody .cart-item');
            if(cartPageItemsList){
              cartPageItemsList.forEach(function(item) {
                  var itemHandle = item.getAttribute('data-handle');
                  if (itemHandle == giftProductHandle) {
                      // localStorage.setItem('GiftNoteVal', '');
                      document.querySelector('.mini-cart__note textarea').value = '';
                      item.querySelector('cart-remove-button').click();
                      localStorage.setItem('GiftLabel', 'Gift wrap this order (+ $5)');
                  }
              });
            }
        }
    });
}

// Initialize gift label on page load
document.addEventListener('DOMContentLoaded', function() {
    // Handle cart drawer interactions
    document.body.addEventListener('click', function(event) {
        if (event.target.matches('.cart-drawer-container') || event.target.matches('summary.header__icon') || event.target.matches('span#cart-icon-bubble')  || event.target.matches('span#cart-icon-bubble svg')) {
            console.log('Event Click');
            // setTimeout(updateGiftLabel, 1500); // Update label after drawer refresh
          var giftCheckbox = document.getElementById('gift-input');
          var giftPopup = document.getElementById('gift_popup');
          if (localStorage.getItem('GiftOrder') == 'true') {
            if (giftCheckbox) giftCheckbox.checked = true;
            
            if (giftPopup) giftPopup.open = true;
          }else{
            if (giftCheckbox) giftCheckbox.checked = false;
            
            if (giftPopup) giftPopup.open = false;
          }
        }
    });

    // Restore textarea content and checkbox state after load
    // setTimeout(updateGiftLabel, 1000);
});
